import MatchedMap from 'utilities/src/matchedMap';

/**
 * Icon Size Enum
 */

export enum SizeEnum {
  Glyph = 'Glyph',
  IconS = 'IconS',
  IconSM = 'IconSM',
  IconM = 'IconM',
  IconL = 'IconL',
  IconXL = 'IconXL',
  Icon2XL = 'Icon2XL',
  Icon3XL = 'Icon3XL',
  Icon4XL = 'Icon4XL',
  Icon5XL = 'Icon5XL',
}

export type SizeType = keyof typeof SizeEnum;

/**
 * Icon Size Map
 */

export const sizeMap = new MatchedMap([
  [SizeEnum.Glyph, 'w-2 h-2'],
  [SizeEnum.IconS, 'w-4 h-4'],
  [SizeEnum.IconSM, 'w-5 h-5'],
  [SizeEnum.IconM, 'w-6 h-6'],
  [SizeEnum.IconL, 'w-8 h-8'],
  [SizeEnum.IconXL, 'w-10 h-10'],
  [SizeEnum.Icon2XL, 'w-12 h-12'],
  [SizeEnum.Icon3XL, 'w-14 h-14'],
  [SizeEnum.Icon4XL, 'w-16 h-16'],
  [SizeEnum.Icon5XL, 'w-20 h-20'],
]);

/**
 * Icon Size Background Map
 */

export const sizeBackgroundMap = new MatchedMap([
  [SizeEnum.Glyph, 'p-[3px] rounded-md'],
  [SizeEnum.IconS, 'p-1 rounded-lg'],
  [SizeEnum.IconSM, 'p-[5px] rounded-[10px]'],
  [SizeEnum.IconM, 'p-[5px] rounded-[10px]'],
  [SizeEnum.IconL, 'p-1.5 rounded-xl'],
  [SizeEnum.IconXL, 'p-2 rounded-[14px]'],
  [SizeEnum.Icon2XL, 'p-2 rounded-2xl'],
  [SizeEnum.Icon3XL, 'p-2 rounded-[18px]'],
  [SizeEnum.Icon4XL, 'p-2 rounded-[20px]'],
  [SizeEnum.Icon5XL, 'p-2 rounded-[22px]'],
]);
